import { API_URL } from '../config/config';
import axios from './axios';

export const getAdminProfile = async (userId: string | any) => {
  const token = localStorage.getItem('token');

  if (!token) throw new Error('No auth token found');

  const response = await axios.get(`${API_URL}/users/${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

export const getAdminUsers = async (adminId: string) => {
  const token = localStorage.getItem('token');

  if (!token) throw new Error('No auth token found');

  const response = await axios.get(`${API_URL}/admin/${adminId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};

export const getWorkerProfileFields = async (id: string | undefined) => {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No auth token found');
  const response = await axios.get(`${API_URL}/worker/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.data;
};
